import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  CircularProgress,
} from 'material-ui';

import {
  ProjectSummaryList,
  StackedGraph,
  StackedAreaGraph,
  InsertBAU,
} from 'imports/ComponentsImports';


const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginLeft: '1em',
  },
  subHeader: {
    margin: '0 0 1em 2em',
  },
  dataContainer: {
    display: 'flex',
    marginBottom: '2em',
  },
  data: {
    flex: 1,
    margin: '0 1em',
  },
  desagregatedGraphsContainer: {
    display: 'flex',
    maxWidth: ''
  },
  desagregatedGraph: {
    flex: 1,
    margin: '1em',
  },
}

class Dashboard extends Component {
  constructor(props){
    super(props);
    this.state = {
      user: this.props.cookies.get('user'),
      token: this.props.cookies.get('token'),
      error: false,
      loading: true,
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar la etapa en la que se encuentra su empresa. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    const yearsBaus = this.state.dataSummary.BAU_per_year
      .map(value => ({year: (new Date(value.date)).getFullYear(), bau: value.value}));
    if(!this.BAUFilled())
      return(
        <InsertBAU
          token={this.state.token}
          user={this.state.user}
          bau={this.state.dataSummary.BAU_per_year}
          indicator={this.state.dataSummary.indicator}
          years={yearsBaus.splice(0, 3)}
          currency={this.state.dataSummary.currency}/>
      )
    const years = yearsBaus
       .map(e => e["year"])
       .map((e, i, final) => final.indexOf(e) === i && i)
       .filter(e => yearsBaus[e]).map(e => yearsBaus[e]);
    const yearInnovationObj = {};
    this.state.dataSummary.innovation_per_year.reduce((r, e) => {
      var key = e.year;
      if (!yearInnovationObj[key]) {
        yearInnovationObj[key] = e;
        r.push(yearInnovationObj[key]);
      } else {
        yearInnovationObj[key].value = yearInnovationObj[key].value + e.value;
      }
      return r;
    }, []);
    const yearInnovation = Object.values(yearInnovationObj).map(inn => ({ year: new Date(inn.year).getFullYear() + 1, value: inn.value }));
    return (
      <div style={styles.container}>
        <h1 style={styles.header}> 3. Dashboard </h1>
        <h2 style={styles.subHeader}> 3.1 Resumen</h2>
        <StackedGraph 
          yearsBaus={years}
          indicator={this.state.dataSummary.indicator} 
          data={yearInnovation}
          header={"i3 vs BAU"}
          currency={this.state.dataSummary.currency}
        />
        <StackedAreaGraph 
          years={years} 
          header={`Aporte por proyecto de innovación al i3 ${years[0].year} - ${years[2].year}`} 
          currency={this.state.dataSummary.currency} 
          indicator={this.state.dataSummary.indicator} 
          data={this.state.dataByProject} 
        />
        <ProjectSummaryList 
          header={`Aporte por proyecto de innovación al i3 ${years[0].year} - ${years[2].year} (${this.state.dataSummary.currency})`}  
          years={years} 
          style={styles.graph} 
          projects={this.state.dataByProject}
        />
      </div>
    );
  }

  BAUFilled = () =>{
    var filled = true;
    this.state.dataSummary.BAU_per_year.forEach((BAU) => {
      if(BAU.value === 0){
        filled = false;
        return;
      }
    })
    return filled;
  }

  getData = () => {
    const connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    const dataSummary = connection.get(routes.dataSummary(this.state.user.company_id));
    const dataByFilter = connection.get(routes.dataByFilter(this.state.user.company_id));
    const dataByProject = connection.get(routes.dataByProject(this.state.user.company_id));
    Promise.all([dataSummary, dataByFilter, dataByProject])
    .then((responses) => {
      this.setState({
        loading: false,
        error: false,
        dataSummary: responses[0].data,
        dataByFilter: responses[1].data,
        dataByProject: responses[2].data
      })
    })
    .catch((error) => {
      this.setState({
        loading: false,
        error: true,
      });
    })
  }
}

export default withRouter(withCookies(Dashboard));



// WEBPACK FOOTER //
// ./src/views/dashboard/DashboardSummaryView.js